// extracted by mini-css-extract-plugin
module.exports = {"hero":"Hero--hero--h6XvW","items":"Hero--items--2YTlp"};